import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../_services/common.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-purchase-order-transaction',
  templateUrl: './purchase-order-transaction.component.html',
  styleUrls: ['./purchase-order-transaction.component.scss']
})
export class PurchaseOrderTransactionComponent implements OnInit {
  static that: PurchaseOrderTransactionComponent;
  tableDetails: ITableModel;
  totalCount: number = 0;
  noOfPages: number = 15;
  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };
  payload: any = {};
  @Input() Id: any;
  @Input() referenceType: any;
  @Input() headerName: any;

  @Input() shipmentModetypearray: any = [];
  @Input() parentTypearray: any = [];

  data: any = {};
  reportHeader: any = [];
  TenantId: any;
  CompanyId: any;
  userId: any;

  FromDate: any = {
    formControlName: 'FromDate',
    dataField: 'FromDate',
    placeholder: 'Select FromDate'
  };
  ToDate: any = {
    formControlName: 'ToDate',
    dataField: 'ToDate',
    placeholder: 'Select ToDate'
  };
  searchFieldDetails: any = {
    placeholder: "Search",
    type: "text",
    isSearchBox: true,
  };
  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private commonService: CommonService,
    private datePipe: DatePipe,
  ) {
    PurchaseOrderTransactionComponent.that = this;
  }

  ngOnInit() {

    this.initalizeForm();

    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    const currentDate = new Date();
    const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

    this.data[this.ToDate.dataField] = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
    this.data[this.FromDate.dataField] = this.datePipe.transform(firstDateOfMonth, 'dd-MMM-yyyy');


  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes['Id']) {
    //   this.Id = changes['Id'].currentValue;
    //   if (this.Id) {
    //     this.GetTransactionList('', 0, {}, this.noOfPages, this.Id)
    //   }
    // }
  }

  async initalizeForm() {
    this.tableDetails = {
      data: [],
      columnDetails: [
        { columnName: 'Purchase Order No', dataFieldName: 'OrderNo', dataFieldName2: 'OrderDate', divType: 'ftlOrders', color: 'var(--colors-primary-blue-blue-200, #3367FB)' },
        { columnName: 'Supplier', dataFieldName: 'Customer', dataFieldName2: 'PickupLocationCode', },
        { columnName: 'Ship To Party', dataFieldName: 'warehouseCode', dataFieldName2: 'warehouseName', dataFieldName3: 'DeliveryLocationCode', },
        { columnName: 'Bill To Party', dataFieldName: 'BillToBranch' },
        { columnName: 'Qty in Case', dataFieldName: 'CaseQty', divType: '' },
        { columnName: 'Total Qty', dataFieldName: 'totalQty', divType: '', alignType: 'right' },
        { columnName: 'Cancel Qty', dataFieldName: 'cancelQty', divType: '', alignType: 'right' },
        { columnName: 'Allocate Qty', dataFieldName: 'allocateQty', divType: '', alignType: 'right' },
        { columnName: 'Pending Qty', dataFieldName: 'pendingQty', divType: '', alignType: 'right' },
        { columnName: 'Weight', dataFieldName: 'Weight', divType: '', alignType: 'right' },
        { columnName: 'Amount', dataFieldName: 'Amount', divType: '', alignType: 'right' },
        { columnName: 'Status', dataFieldName: 'POStatus', divType: 'status' },
      ],
      isColumnNameShow: true
    }
  }

  getChangedValue(value, data) {
    if (data.dataField == 'FromDate') {
      if (value != null) {
        this.data[this.FromDate.dataField] = value;
      }
    }
    if (data.dataField == 'ToDate') {
      if (value != null) {
        this.data[this.ToDate.dataField] = value;
        // this.GetTransactionList('', 0, {}, this.noOfPages, this.Id)
      }
    }
  }

  GetTransactionList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id,
    CompanyId
  ) {

    Helpers.setLoading(true);

    this.payload.Start = pageNo * perPage;
    this.payload.Length = perPage;
    this.payload.SearchValue = searchValue || null;
    this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;
    this.payload.OrderNo = null;

    if (this.parentTypearray.includes('supplier') || this.shipmentModetypearray.includes('warehouse/cfs/yard') || this.shipmentModetypearray.includes('warehouse') || this.shipmentModetypearray.includes('supplier')) {
      this.payload.SupplierName = Id ? Id : this.Id;
    }
    else {
      this.payload.SupplierName = null;
    }

    this.payload.ShipTo = null;
    this.payload.AllocationStatus = 'All';
    this.payload.FromDate = this.data.FromDate;
    this.payload.ToDate = this.data.ToDate;
    this.payload.Status = null;

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;


    this._appService.Post("OrdersByVehicle", "obv_GetPOList_NewFlow", this.payload).subscribe((response) => {
      if (response.length) {
        this.totalCount = response[0].recordcount;
        // this.isListApiCalled = true;
      }
      this.assignTableFields(pageNo, perPage, response);
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while fetching data", err);
      }
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data,
    }
  }


  GetTransactionListDownload(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id

  ) {
    Helpers.setLoading(true);
    localStorage.setItem('perPage', perPage);
    // this.payload.Start = pageNo;
    // this.payload.Length = this.totalCount;
    // this.payload.SearchValue = this.searchValue || null;
    // this.payload.CompanyId = this.CompanyId;
    // this.payload.OrderNo = null;

    // if(this.parentTypearray.includes('supplier') || this.shipmentModetypearray.includes('warehouse/cfs/yard') || this.shipmentModetypearray.includes('warehouse')  || this.shipmentModetypearray.includes('supplier') ){
    //   this.payload.SupplierName = Id ? Id : this.Id;
    // }
    // else 
    // {
    //   this.payload.SupplierName = null ;
    // }

    // this.payload.ShipTo = null;
    // this.payload.AllocationStatus = 'All';
    // this.payload.FromDate = this.data.FromDate;
    // this.payload.ToDate = this.data.ToDate;
    // this.payload.Status = null;


    this.payload.Start = pageNo;
    this.payload.Length = this.totalCount;
    this.payload.SearchValue = searchValue || null;
    this.payload.CompanyId = this.CompanyId;
    this.payload.OrderNo = null;

    if (this.parentTypearray.includes('supplier') || this.shipmentModetypearray.includes('warehouse/cfs/yard') || this.shipmentModetypearray.includes('warehouse') || this.shipmentModetypearray.includes('supplier')) {
      this.payload.SupplierName = Id ? Id : this.Id;
    }
    else {
      this.payload.SupplierName = null;
    }

    this.payload.ShipTo = null;
    this.payload.AllocationStatus = 'All';
    this.payload.FromDate = this.data.FromDate;
    this.payload.ToDate = this.data.ToDate;
    this.payload.Status = null;
    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;

    this._appService.Post("OrdersByVehicle", "obv_GetPOList_NewFlow_Download", this.payload).subscribe((response) => {
      this.DownloadFile(response);
      Helpers.setLoading(false);
    },
      (error) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while downloading", error);
      }
    );
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }



}
